import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/collections/CollectionGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/PackageSearch.tsx");
